import { createReducer } from '../../Helpers/redux';

import {GET_ALL_PROVIDERS, GET_PROVIDERS} from '../actions/providers';

import {IPayloadReducer, IProvidersState} from "../types/providers";

const initialState: IProvidersState = {
    providers: [],
    allProviders: [],
    allProvidersFetchedAt: null,
    error: null,
}

const handlers = {
    [GET_PROVIDERS + '.SUCCESS']: (prevState: IProvidersState, { payload }: IPayloadReducer<IProvidersState['providers']>) => {
        return {
            ...prevState,
            ...payload,
            error: null
        }
    },
    [GET_ALL_PROVIDERS + '.SUCCESS']: (prevState: IProvidersState, { payload }: IPayloadReducer<Pick<IProvidersState, 'providers'>>) => {
        return {
            ...prevState,
            allProviders: payload.providers,
            allProvidersFetchedAt: Date.now(),
        }
    },
    [GET_PROVIDERS + '.FAILURE']: (prevState: IProvidersState, { payload }: IPayloadReducer<IProvidersState['error']>) => {
        return {
            ...prevState,
            error: payload
        }
    },
}

export default createReducer(initialState, handlers);